// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"40":"d0949763","171":"dc289cf5","453":"37a4820d","456":"03dd6974","507":"33d9e2f1","563":"f9da3acc","845":"6f417f88","870":"0f985843"}[chunkId] + ".chunk.js";
};